import type { RxJsonSchema } from 'rxdb';
import type { TrafficSafetyScore } from './trafficSafetyScore.types';

export const trafficSafetyScoreSchema: RxJsonSchema<TrafficSafetyScore> = {
  type: 'object',
  version: 0,
  description: 'describes Traffic Safety',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    discipline: { type: ['number', 'null'] },
    sort: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};
